import { render, staticRenderFns } from "./NoBindUser.vue?vue&type=template&id=4cf9b6f8&"
import script from "./NoBindUser.vue?vue&type=script&lang=js&"
export * from "./NoBindUser.vue?vue&type=script&lang=js&"
import style0 from "./NoBindUser.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports